module.exports = __webpack_public_path__ + "img/advertising.130cf032.png";